import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function Acquisition() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Dashboards" breadcrumbItem="Acquisition" />
          <h4>Acquisition</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Acquisition;
